import React from 'react';
import Link from '@mui/material/Link';
import { useNavigate } from 'react-router-dom';

interface Props {
	to: string;
	/** Passed through to react-router so the target page can render a title before its data loads. */
	state?: unknown;
	children: React.ReactNode;
}

/**
 * Row link for DataGrid cells: client-side navigation on a plain click,
 * native anchor behaviour (new tab, etc.) on ctrl/cmd/shift/middle click.
 */
export default function AdminGridLink({ to, state, children }: Props) {
	const navigate = useNavigate();
	return (
		<Link
			href={to}
			variant="body2"
			onClick={(e: React.MouseEvent) => {
				if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button === 0) {
					e.preventDefault();
					navigate(to, { state });
				}
			}}
			sx={{ textAlign: 'left' }}
		>
			{children}
		</Link>
	);
}
